<template>
    <div class="sa-noshow-list">
        <span class="sa-date sa-h-sm-up">{{data.time}}</span>
        <span class="sa-black-text"
          >{{data.product}} -<span class="sa-gray-text">Appointment ID : {{data.apnt_id}}</span></span
        >
        <!-- <div class="sa-ins-apt">
          <span class="sa-refill">Refill</span
          ><span class="sa-bupa-str"
            ><i class="icon-Insurance2"></i> Bupa Appointment</span
          >
        </div> -->
        <div class="sa-d-f-sbetween sa-pt10">
            <span>{{data.date}}</span>
            <span>{{data.start_time}}</span>
        </div>
      </div>
</template>
<script>
export default {
  props:['data'],
    data() {
        return {
            
        }
    },
}
</script>